/**
 * ReadyRowsSection — Gate-Panel + Zeilenliste + Pagination des „Bereit"-Tabs
 * (T8). Ausgelagert aus `ReadyBulkList.tsx` wegen des Component-Size-Limits.
 */
import { Pagination } from '@/components/v2/ui'
import { EID } from '@/lib/element-ids.registry'
import type { ChannelContentSuggestion } from '@/lib/api/channel-content-bulk'

import { ReadyRow } from './ReadyRow'
import { ReadyGatePanel } from './ReadyGatePanel'

export interface ReadyRowsSectionProps {
  items: ChannelContentSuggestion[]
  channelNameById: Record<string, string>
  productLabelById: Record<string, string>
  everSeenIds: Set<string>
  openIds: Set<string>
  isBusy: (id: string) => boolean
  onToggle: (id: string) => void
  onApplyRow: (id: string, editedValue?: string | string[]) => void
  onDiscardRow: (id: string) => void
  page: number
  totalPages: number
  onPageChange: (page: number) => void
}

export function ReadyRowsSection({
  items,
  channelNameById,
  productLabelById,
  everSeenIds,
  openIds,
  isBusy,
  onToggle,
  onApplyRow,
  onDiscardRow,
  page,
  totalPages,
  onPageChange,
}: ReadyRowsSectionProps) {
  return (
    <>
      <ReadyGatePanel checkedCount={everSeenIds.size} total={items.length} />
      <div className="space-y-2">
        {items.map((s) => (
          <ReadyRow
            key={s.id}
            suggestion={s}
            channelName={channelNameById[s.channel_id] ?? s.channel_id.slice(0, 8)}
            productLabel={productLabelById[s.product_id] ?? s.product_id.slice(0, 8)}
            everSeen={everSeenIds.has(s.id)}
            open={openIds.has(s.id)}
            busy={isBusy(s.id)}
            onToggle={() => onToggle(s.id)}
            onApply={(editedValue) => onApplyRow(s.id, editedValue)}
            onDiscard={() => onDiscardRow(s.id)}
          />
        ))}
      </div>
      {totalPages > 1 && (
        <div
          id={EID['text-bulk-ready-pagination-region']}
          className="flex justify-end border-t border-neutral-200 pt-4 dark:border-neutral-800"
        >
          <Pagination currentPage={page} totalPages={totalPages} onPageChange={onPageChange} />
        </div>
      )}
    </>
  )
}
